import { useState } from 'react'
import { useGetAllLeaveRequests } from '../../assets/nodeApi/getApi/getCommonApi'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { Button, Typography } from '@mui/material'
import { getFormattedDateTable } from '../../shared/formatter'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { patchLeaveStatus } from '../../assets/nodeApi/patchApi/patchCommonApi'
import { useToaster } from '../../shared/utils/ToasterProvider'

const LeaveRequestList = () => {

    const queryClient=useQueryClient()
   
    const { showToaster } = useToaster();
    const { data: leaveRequestData, isLoading: isLeaveRequestLoading } = useGetAllLeaveRequests();
    const [actionType, setActionType] = useState(null);
    const [activeRowId, setActiveRowId] = useState(null);
    const mutationUpdateStatus = useMutation({
        mutationFn: ({ id, formdata }) => patchLeaveStatus(id, formdata),
        onSuccess: (_, variables) => {
            const { formdata } = variables;
            const trainerResponse = formdata.status;

            showToaster(
                `Response ${trainerResponse === 'APPROVED' ? 'accepted' : 'rejected'} successfully`,
                '',
                'success'
            );

            queryClient.invalidateQueries(['trainer-leaves/all']);
            setActiveRowId(null);
        },
        onError: (err) => {
            showToaster(err?.response?.data?.error || 'Failed to update response', '', 'error');
            setActiveRowId(null);
        },
    });

    const leaveRequestRow = leaveRequestData?.data?.map((item, index) => ({
        id: item?.id || index + 1,
        sr_no: index + 1,
        ...item
    })) ?? [];

    const leaveRequestColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "trainer_name",
            headerName: "Trainer Name",
            flex: 1,
            renderCell: (params) => (
                <Typography variant="body2">
                    {params?.value}
                </Typography>
            ),
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.value}</Typography>,
        },
        {
            field: "start_date",
            headerName: "Start Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{getFormattedDateTable(params.value)}</Typography>,
        },
        {
            field: "end_date",
            headerName: "End Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{getFormattedDateTable(params.value)}</Typography>,
        },
         {
            field: "total_days",
            headerName: "Total Days",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "reason",
            headerName: "Reason",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "accept",
            headerName: "Accept",
            width: 120,
            renderCell: (params) => {
                const status = params?.row?.status;
                const isProcessing = mutationUpdateStatus.isPending && activeRowId === params?.row?.id;
                const isDisabled = status !== "PENDING" || isProcessing;

                return (
                    <Button
                        variant="contained"
                        size="small"
                        disabled={isDisabled}
                        onClick={() => {
                            setActionType('Accepted');
                            setActiveRowId(params?.row?.id);
                            mutationUpdateStatus.mutate({ id: params?.row?.leave_group_id, formdata: { status: 'APPROVED' } });
                        }}
                    >
                        {isProcessing && actionType === 'Accepted'
                            ? 'Accepting...'
                            : 'Accept'}
                    </Button>
                );
            },
        },
        {
            field: "reject",
            headerName: "Reject",
            width: 120,
            renderCell: (params) => {
                const status = params?.row?.status;
                const isProcessing = mutationUpdateStatus.isPending && activeRowId === params?.row?.id;
                const isDisabled = status !== "PENDING" || isProcessing;

                return (
                    <Button
                        variant="contained"
                        size="small"
                        disabled={isDisabled}
                        onClick={() => {
                            setActionType('Rejected');
                            setActiveRowId(params?.row?.id);
                            mutationUpdateStatus.mutate({ id: params?.row?.leave_group_id, formdata: { status: 'REJECTED' } });
                        }}
                    >
                        {isProcessing && actionType === 'Rejected'
                            ? 'Rejecting...'
                            : 'Reject'}
                    </Button>
                );
            },
        },
    ];

    return (
        <TableFilterTemplate
            title="Leave Requested List"
            columns={leaveRequestColumns}
            rowsData={leaveRequestRow}
            isLoading={isLeaveRequestLoading}
            // renderFilterFields={() => <></>}
        />
    );
};

export default LeaveRequestList;
